import React, {useEffect,useState} from 'react'
import {FormField,Select,Text} from 'grommet'
import countries from './countries.json'
import {Globe} from 'grommet-icons'
import {PostalCodeRequired} from './utils/shared/shared'
const defaultOptions = [];
countries.countries.map(c => {
defaultOptions.push(c)
return defaultOptions
})


function CountriesDropdown(props) {
    const [countries, setCountries] = useState([]);
    const [country, setCountry] = useState({CountryName: 'Select Country...', CountryCode: ""});
    const [name, setName] = useState('')
        useEffect(() => {    
            setCountries(defaultOptions)
            if (props.value === undefined){
              if (props.name === 'Origin'){
                setName('OriginCountry')
                props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
              } else if (props.name === 'Destination'){
                setName('DestinationCountry')
                props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
              } else if (props.hasOwnProperty('layer')){
                setName('country')
                setCountry(props.country)
              } else if (props.country !== undefined){
                setName('Country')
                setCountry(props.country)
              } else {
                setName('Country')
              }
            } else {
              if (props.requote){
                if (props.name === 'Origin'){
                  setName('OriginCountry')
                  setCountry(props.value.OriginCountry)
                  props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
                } else if (props.name === 'Destination'){
                  setName('DestinationCountry')
                  setCountry(props.value.DestinationCountry)
                  props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
                } else if (props.hasOwnProperty('layer')){
                  setName('country')
                  setCountry(props.country)
                } else if (props.country !== undefined){
                  setName('Country')
                  setCountry(props.country)
                } else {
                  setName('Country')
                }
              } else {
              if (props.name === 'Origin'){
                setName('OriginCountry')
                props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
              } else if (props.name === 'Destination'){
                setName('DestinationCountry')
                props.setPostCodeRequired(PostalCodeRequired(country.CountryCode))
              } else if (props.hasOwnProperty('layer')){
                setName('country')
                setCountry(props.country)
              } else if (props.country !== undefined){
                setName('Country')
                setCountry(props.country)
              } else {
                setName('Country')
              }
            }
          }
         },[props]);
  return (
    <FormField required name={name}label={<Text size={props.size}>Country</Text>}  margin='small'>
      <Select
          placeholder={`${country.CountryName}`} icon={<Globe />} size={props.size} name={name} value={country} options={countries} labelKey="CountryName" valueKey="CountryCode" onChange={({ option }) => setCountry(option)} onClose={() => setCountries(defaultOptions)}
          onSearch={text => {
            const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
            const exp = new RegExp(escapedText, 'i');
            setCountries(defaultOptions.filter(o => exp.test(o.CountryName)));
          }}
        />
    </FormField>
  )
}

export default CountriesDropdown
